import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import TrendsCard from "../card/TrendsCard/TrendsCard";
import { IonButton, IonIcon, useIonRouter } from "@ionic/react";
import { CreateCommunityButton } from "../modal/CreateCommunityModal";
import { IoIosPeople } from "react-icons/io";
import { informationCircleOutline, searchOutline } from "ionicons/icons";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

export const Search = () => {
  const { t } = useTranslation();
  const [value, setValue] = useState("");
  const router = useIonRouter();
  const keyDownFunction = async (e) => {
    if (((e.key === "Enter" && !e.shiftKey) || e.type === "click") && value) {
      e.preventDefault(); // prevent newline
      router.push("/search?q=" + value);
    }
  };
  return (
    //   <input
    //     className="search-input"
    //     type="search"
    //     placeholder={t("searchPlaceholder")}
    //     onKeyDown={keyDownFunction}
    //     value={value}
    //     onChange={(e) => setValue(e.target.value)}
    //   />
    // );
    <div className="sidebar-right__search-bar">
      <Link to="/home/discover">
        <img src="/logo4.png" alt="LoonLog Logo" className="search-logo" />
      </Link>
      <div className="search-container">
        <IonIcon icon={searchOutline} className="search-icon" />
        <input
          className="search-input poppins"
          type="search"
          placeholder={t("searchPlaceholder")}
          onKeyDown={keyDownFunction}
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
      </div>
    </div>
  );
};
function SidebarRight() {
  const { t } = useTranslation();
  return (
    <aside className="sidebar-right">
      <Search />
      <div className="trends">
        <div className="trending-title">
          <div style={{ display: "flex", gap: "4px", alignItems: "center" }}>
            <IonButton
              routerLink="/community-faq"
              fill="clear"
              style={{
                "--padding-top": "0",
                "--padding-bottom": "0",
                "--padding-start": "4px",
                "--padding-end": "4px",
                // fontSize: "1.2rem",
                color: "#d80621",
                height: "unset", // Removes default Ionic height
              }}
            >
              <IonIcon
                fill="clear"
                style={{ color: "#d80621", fontSize: "1.1rem" }}
                icon={informationCircleOutline}
              />
            </IonButton>
            <IoIosPeople size={20} style={{ display: "block" }} />
            <h3 className="local-header" style={{ margin: 0, lineHeight: 1 }}>
              {t("trendsTitleBig")}
            </h3>
          </div>
          <CreateCommunityButton screen="desktop" />
        </div>
        {/* <span>{t("trendsDesc")}</span> */}
        <TrendsCard />
        {/* <a>{t("trends.showMore")}</a> */}
      </div>
    </aside>
  );
}

export default SidebarRight;
